import {Disclosure} from '@headlessui/react'
import classNames from 'classnames'
import * as React from 'react'

import {makeEditable} from '@/common/utils'
import Content from '@/components/Content'
import {Grid} from '@/components/Grid'
import Heading from '@/components/Heading'

const FAQ = ({backgroundColors, id, headingTag, heading, items = [], _editable}) => {
  const HeadingTag = headingTag || 'p'
  const [lastDropdownClose, setLastDropdownClose] = React.useState()

  function exclusiveDropdown(close) {
    if (lastDropdownClose && !(close === lastDropdownClose)) {
      lastDropdownClose()
    }
    setLastDropdownClose(() => close)
  }

  return (
    <section
      id={id ? id : undefined}
      {...makeEditable(_editable)}
      className={classNames('py-24', backgroundColors.current)}
    >
      <Grid>
        <HeadingTag className='col-span-full flex flex-col items-center space-y-8 pb-22 text-center md:col-span-4 md:col-start-2 lg:col-span-6 lg:col-start-4'>
          <Heading heading={heading} />
        </HeadingTag>
        <div className='col-span-full divide-y divide-purple-900 border-b border-purple-900'>
          {items.map(({_uid, tag, heading, content}) => {
            return (
              <Disclosure as='div' key={_uid} className='py-8'>
                {({open, close}) => (
                  <>
                    <Disclosure.Button
                      className='group relative flex w-full items-center justify-between py-6'
                      onClick={() => {
                        if (exclusiveDropdown) {
                          exclusiveDropdown(close)
                        }
                      }}
                    >
                      <div className='wrapper w-fit text-left'>
                        <div className='polygon hidden lg:block' />
                        <div className='polygon hidden lg:block' />
                        <div className='polygon hidden lg:block' />
                        <div className='polygon hidden lg:block' />
                        <span
                          className={classNames(
                            'heading heading-s-millik text-left [-webkit-text-stroke:theme(colors.purple.900)_1px]',
                            {'!text-purple-900': open},
                            {'text-transparent': !open}
                          )}
                          data-text={heading}
                        >
                          {heading}
                        </span>
                      </div>

                      {tag && open && (
                        <span className='heading-xs-millik absolute -top-5 left-10 block -rotate-6 rounded-xl bg-yellow-400 py-2 px-4 text-violet-400 md:-top-1/4 md:left-1/2'>
                          {tag}
                        </span>
                      )}
                    </Disclosure.Button>

                    <Disclosure.Panel
                      className={classNames(
                        'grid transition-all duration-300 md:pr-26',
                        open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                      )}
                      static
                    >
                      <div className='overflow-hidden'>
                        <Content className='py-2 !text-purple-400' content={content} />
                      </div>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            )
          })}
        </div>
      </Grid>
    </section>
  )
}

export default FAQ
